/**
 * Shared layer visibility type definitions and utilities.
 *
 * Used by both layout.ts and route.ts to check if content supports
 * layer visibility toggling and stack access.
 */

import { layout } from "GenAlphaModel";

/** Interface for content that supports layer visibility */
export interface ContentWithLayerVisibility {
  isLayerVisible(layerNumber: number): boolean;
}

/** Interface for content that has stack access */
export interface ContentWithStack {
  stack: layout.Stack | null;
}

/**
 * Type guard to check if content has stack access for via definitions.
 *
 * @param content - The content object to check (typically the root content)
 * @returns True if the content has a stack property
 */
export function hasStack(content: unknown): content is ContentWithStack {
  if (typeof content !== "object" || content === null) {
    return false;
  }
  return "stack" in content;
}
